export const PARAMETERS = 'parameters';

// FTS0015
export const FTS0015_TREATMENT_KEY = 'fts-0015';
export const FTS0015_GROUP_PARAMETER_KEY = 'group';
export let FTS0015_GROUP_PARAMETER_OPTIONS;
(function (FTS0015_GROUP_PARAMETER_OPTIONS) {
  FTS0015_GROUP_PARAMETER_OPTIONS["control"] = "control";
  FTS0015_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(FTS0015_GROUP_PARAMETER_OPTIONS || (FTS0015_GROUP_PARAMETER_OPTIONS = {}));